export interface ComparisonSummaryParameters<TDataOld, TDataNew = TDataOld> {
	requiresReview: boolean;
	allowEdits: boolean;
	oldData?: TDataOld;
	newData?: TDataNew;
}

export default class ComparisonSummary<TDataOld, TDataNew = TDataOld> {
	public requiresReview: boolean;
	public allowEdits: boolean;
	public oldData?: TDataOld;
	public newData?: TDataNew;

	public constructor(params: ComparisonSummaryParameters<TDataOld, TDataNew>) {
		this.requiresReview = params.requiresReview;
		this.allowEdits = params.allowEdits;
		this.oldData = params.oldData;
		this.newData = params.newData;
	}
}